import React from "react";

import { useBoards } from "Boards/BoardContext";

import DeleteButton from "../DeleteButton";
import useBoardLocation from "../hooks/useBoardLocation";

import DeleteOrArchive from "./DeleteOrArchive";

function DeleteAndArchiveButton() {
  const [{ boardID, groupURL, isShared }] = useBoards();

  const { isReportBoard, isGroupBoard } = useBoardLocation();

  if (isGroupBoard) {
    return (
      <DeleteButton boardID={boardID} groupURL={groupURL} isShared={isShared} />
    );
  }

  if (isReportBoard) {
    return <DeleteOrArchive />;
  }

  return null;
}

export default DeleteAndArchiveButton;
